import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProductionService from "services/ProductionService";

export const initialState = {
  loading: false,
  message: "",
  list: null
};

export const stageListAll = createAsyncThunk(
  "/stage/list",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductionService.getStage(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const stageSlice = createSlice({
  name: "stage",
  initialState,
  reducers: {
    stageList: (state, action) => {
      state.loading = true;
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stageListAll.pending, (state) => {
        state.loading = false;
      })
      .addCase(stageListAll.fulfilled, (state, action) => {
        state.loading = true;
        state.list = action.payload;
      });
  },
});

export const { stageList } = stageSlice.actions;

export default stageSlice.reducer;
